// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"8f4a074f","455":"bbea6fed","829":"52beedab"}[chunkId] + ".chunk.js";
};